import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import React from 'react';
import { Tag } from 'antd';
import {
    CheckCircleOutlined,
    ClockCircleOutlined,
    CloseCircleOutlined,
    MinusCircleOutlined,
} from '@ant-design/icons';
import { canAccessPlayerProfile, currencyUtils } from "../../../../../utils";

const PlayersTableColumns = (currencyCode: string) => {
    const { t } = useTranslation();
    const shouldLinkToPlayerProfile = canAccessPlayerProfile();

    return [
        {
            title: t('id'),
            dataIndex: 'id',
            key: 'id',
            width: 90,
        },
        {
            title: t('playerId'),
            dataIndex: 'playerId',
            key: 'playerId',
            render: (text: string) =>
                shouldLinkToPlayerProfile ? (
                    <Link to={`/casino/players/null/${text}`}>{text}</Link>
                ) : (
                    <span>{text}</span>
                ),
            sorter: true,
            width: 150,
        },
        {
            title: t('receivedAt'),
            dataIndex: 'receivedAt',
            key: 'receivedAt',
            sorter: true,
            width: 200,
        },
        {
            title: () => (
                <span className="table-title__span">
                    {t('totalBet')}
                    <span>{currencyCode}</span>
                </span>
            ),
            dataIndex: 'totalBet',
            key: 'totalBet',
            sorter: true,
            width: 130,
            render: (text: string) => (currencyUtils.getFormattedCurrency(Number(text), currencyUtils.getCurrencyDataByCode(currencyCode).subunit))
        },
        {
            title: () => (
                <span className="table-title__span">
                    {t('totalWin')}
                    <span>{currencyCode}</span>
                </span>
            ),
            dataIndex: 'totalWin',
            key: 'totalWin',
            sorter: true,
            width: 130,
            render: (text: string) => (currencyUtils.getFormattedCurrency(Number(text), currencyUtils.getCurrencyDataByCode(currencyCode).subunit))
        },
        {
            title: 'Played Features',
            dataIndex: 'roundsPlayed',
            key: 'roundsPlayed',
            width: 130,
        },
        {
            title: t('lastRoundDate'),
            dataIndex: 'lastRoundDate',
            key: 'lastRoundDate',
            width: 200,
        },
        {
            title: t('status'),
            dataIndex: 'status',
            key: 'status',
            width: 120,
            render: (text: string) => {

                if (text === 'QUEUED') {
                    return (
                        <Tag icon={<ClockCircleOutlined />} color="processing">
                            Queued
                        </Tag>
                    );
                } else if (text === 'IN_USE') {
                    return (
                        <Tag icon={<CheckCircleOutlined />} color="geekblue">
                            In Use
                        </Tag>
                    );
                } else if (text === 'OPT_OUT') {
                    return (
                        <Tag icon={<CloseCircleOutlined />} color="magenta">
                            Opted Out
                        </Tag>
                    );
                } else if (text === 'COMPLETED') {
                    return (
                        <Tag icon={<CheckCircleOutlined />} color="success">
                            Completed
                        </Tag>
                    );
                } else if (text === 'CANCELLED') {
                    return (
                        <Tag icon={<CloseCircleOutlined />} color="error">
                            Cancelled
                        </Tag>
                    );
                } else if (text === 'EXPIRED') {
                    return (
                        <Tag icon={<MinusCircleOutlined />} color="warning">
                            Expired
                        </Tag>
                    );
                }
            },
        },
    ];
};

export default PlayersTableColumns;
